import type { ReactElement } from 'react';

import classNames from 'classnames';

import type { FCC } from '../../types/common';
import { ui } from '../../utils/helpers';
import PageBlockHeader from '../page_block_header/page_block_header';

import styles from './page_block.module.css';

type Props = {
  className?: string;
  contentClassName?: string;
  title?: string | ReactElement;
  actionElements?: ReactElement[];
  scrollable?: boolean;
  uiKey?: string;
  ariaLabel?: string;
};

const PageBlock: FCC<Props> = ({
  title,
  children,
  className,
  contentClassName,
  actionElements = [],
  scrollable,
  uiKey,
  ariaLabel,
}) => (
  <div
    role="complementary"
    aria-label={typeof title === 'string' ? title : ariaLabel}
    className={classNames(styles.root, className)}
    {...(uiKey && ui(uiKey))}
  >
    {title ? (
      <PageBlockHeader
        className={styles.header}
        title={title}
        actionElements={actionElements}
      />
    ) : null}
    <div
      className={classNames(styles.content, contentClassName, {
        [styles.scrollable]: scrollable,
      })}
    >
      {children}
    </div>
  </div>
);

export default PageBlock;
